import React, { FunctionComponent } from "react";
import { useIntl } from "react-intl";
import { ReactComponent as IconFilledStar } from "@Icons/filled-star.svg";
import { ProductPage, SubCategory } from "@Types/header";
import { setDataLayerTrack } from "@Utils/track";
import "./style.scss";

export interface Props {
  subCategory: SubCategory;
}

const HeaderSubCategory: FunctionComponent<Props> = ({ subCategory }) => {
  const intl = useIntl();
  const localeSlug = intl.locale;

  return (
    <div className="HeaderSubCategory">
      <div className="HeaderSubCategory-title">{subCategory.title}</div>
      {subCategory.productPages.map((product: ProductPage, index: number) => {
        return (
          <a
            className="HeaderSubCategory-product"
            href={`/${localeSlug}${product.url}`}
            key={`${product.title}-${index}`}
            onClick={() =>
              setDataLayerTrack("Product List Clicked", {
                categoryPageTag: product.tag,
                linkPosition: "Menu",
              })
            }
          >
            <div className="HeaderSubCategory-product-title">
              <span>{product.title}&nbsp;</span>
              {product.label && (
                <span
                  className="HeaderSubCategory-product-label"
                  style={{ backgroundColor: product.labelColor }}
                >
                  {product.label}
                </span>
              )}
              {product.starred && <IconFilledStar className="HeaderSubCategory-product-star" />}
            </div>
          </a>
        );
      })}
    </div>
  );
};

export default HeaderSubCategory;
